import * as L from 'leaflet';
import { loc_equal } from 'shared/map/lib/utils';
import { createElementHook, createElementObject, useLeafletContext, } from '@react-leaflet/core';
import { useEffect, useRef } from 'react';
//
function switchIcon(instance, props, icon_index) {
    const new_icon_index = icon_index++;
    instance.options.className =
        props.icon_classes[new_icon_index % props.icon_classes.length];
    // leafletElement.setIcon(icon);
    return [instance, new_icon_index];
}
function createBlinkingMarker(props, context) {
    const marker = L.marker(props.position, props);
    marker.on('click', () => props?.onClick());
    return createElementObject(marker, context);
}
function updateBlinkingMarker(instance, props, prevProps) {
    if (!loc_equal(prevProps.position, props.position)) {
        instance.setLatLng(props.position);
    }
}
const useBlinkingMarkerElement = createElementHook(createBlinkingMarker, updateBlinkingMarker);
export const BlinkingMarker = (props) => {
    const context = useLeafletContext();
    const markerRef = useBlinkingMarkerElement(props, context);
    const iconRef = useRef();
    const propsRef = useRef(props);
    const timer_ref = useRef(null);
    const icon_index_ref = useRef(0);
    useEffect(() => {
        const icon = L.divIcon({
            className: props.icon_classes[0],
            iconSize: [props.icon_size, props.icon_size],
            iconAnchor: props.icon_anchor != null
                ? props.icon_anchor
                : [props.icon_size / 2, props.icon_size / 2],
        });
        iconRef.current = icon;
        markerRef.current.instance.setIcon(icon);
        timer_ref.current = setInterval(() => {
            if (iconRef.current == null) {
                return;
            }
            [iconRef.current, icon_index_ref.current] = switchIcon(iconRef.current, props, icon_index_ref.current);
        }, 1e3);
        const container = context.layerContainer || context.map;
        container.addLayer(markerRef.current.instance);
        return () => {
            if (timer_ref.current) {
                clearInterval(timer_ref.current);
            }
            container.removeLayer(markerRef.current.instance);
        };
    }, []);
    useEffect(() => {
        if (propsRef.current.icon_classes !== props.icon_classes) {
            if (iconRef.current) {
                [iconRef.current, icon_index_ref.current] = switchIcon(iconRef.current, props, icon_index_ref.current);
            }
        }
        if (!loc_equal(propsRef.current.position, props.position))
            markerRef.current.instance.setLatLng(props.position);
        if (propsRef.current.icon_size !== props.icon_size ||
            (propsRef.current.icon_anchor == null && props.icon_anchor) ||
            (propsRef.current.icon_anchor && props.icon_anchor == null) ||
            (propsRef.current.icon_anchor &&
                props.icon_anchor &&
                !loc_equal(propsRef.current.icon_anchor, props.icon_anchor))) {
            if (iconRef.current) {
                iconRef.current.options.iconSize = [props.icon_size, props.icon_size];
                iconRef.current.options.iconAnchor =
                    props.icon_anchor != null
                        ? props.icon_anchor
                        : [props.icon_size / 2, props.icon_size / 2];
                markerRef.current.instance.setIcon(iconRef.current);
            }
        }
        propsRef.current = props;
    }, [props]);
    return null;
};
